<template>
  <div class="head-description">
    <div class="dark wrapper">
        <img
          src="@/assets/banner.jpg"
          alt="Kick and Quatsch Logo"
        />
        <div>
          <div class="logo-container">
              <a
                class="icon-link"
                href="https://www.instagram.com/kickandquatsch"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="mdi:instagram"
                  color="#000000"
                  width="30"
                  height="30"
                />
              </a>
              <a
                class="icon-link"
                href="https://www.facebook.com/kickandquatsch"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="mdi:facebook"
                  color="#000000"
                  width="30"
                  height="30"
                />
              </a>
              <a
                class="icon-link"
                href="https://open.spotify.com/show/7yG8udb8cMI5qg3ZIkG4B6"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="mdi:spotify"
                  color="#000000"
                  width="30"
                  height="30"
                />
              </a>
              <a
                class="icon-link"
                href="https://podcasts.apple.com/de/podcast/kick-and-quatsch/id1546702903"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="hugeicons:apple-music"
                  color="#000000"
                  width="30"
                  height="30"
                />
              </a>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import { Icon } from '@iconify/vue2';

//import BaseIcon from "@/components/BaseIcon.vue";
export default {
  components: {
    Icon,
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
@media (max-width: 1369.9px) {
  .logo-container {
    display: none !important;
  }
}
.logo-container {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    padding-top: 20px;
    gap: 10px;
    a {
      padding:10px;
      background-color: #fff;
      border-radius: 100%;
      svg {
        display: flex;
        align-items: center;
      }
    }
  }
</style>
